import { EntityStatus } from "@/enums";
import { Form, Radio, Tooltip, Typography } from "antd";
import { bool, func, object, string } from "prop-types";
import { useEffect, useRef } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { toast } from "react-toastify";

const { Title } = Typography;

const EntityStatusInput = ({
  parentComponent,
  field,
  validateProjectMilestoneActive,
  isNewProjectType,
}) => {
  const intl = useIntl();
  const fieldName = field ? field.name : "property";
  const inactiveRef = useRef(null);
  const activeRef = useRef(null);

  useEffect(() => {
    if (isNewProjectType && inactiveRef?.current && activeRef?.current) {
      inactiveRef.current.input.click();
      activeRef.current.input.onclick = (e) => {
        toast.error(
          intl.formatMessage({
            id: `entityStatusInput.noMilestones`,
          })
        );
        inactiveRef.current.input.click();
        e.stopPropagation();
      };
    }
  }, [isNewProjectType, inactiveRef, activeRef, intl]);

  return (
    <Form.Item
      isListField={field?.isListField}
      name={[fieldName, "status"]}
      label={
        !field && (
          <Title level={3} style={{ margin: 0 }}>
            <FormattedMessage id="newFormField.status" />
          </Title>
        )
      }
    >
      <Radio.Group>
        <Tooltip
          title={intl.formatMessage({
            id: `enum.entityStatus.${EntityStatus.Active.toLowerCase()}`,
          })}
        >
          <Radio.Button
            data-test-id={`${parentComponent}-entity-status-active`}
            value={EntityStatus.Active}
            ref={activeRef}
            onClick={() =>
              validateProjectMilestoneActive &&
              validateProjectMilestoneActive(field, inactiveRef)
            }
          >
            <FormattedMessage
              id={`enum.entityStatus_abbreviation.${EntityStatus.Active}`}
              defaultMessage="A"
            />
          </Radio.Button>
        </Tooltip>
        <Tooltip
          title={intl.formatMessage({
            id: `enum.entityStatus.${EntityStatus.Inactive.toLowerCase()}`,
          })}
        >
          <Radio.Button
            data-test-id={`${parentComponent}-entity-status-inactive`}
            value={EntityStatus.Inactive}
            ref={inactiveRef}
            id={`${parentComponent}-entity-status-inactive`}
          >
            <FormattedMessage
              id={`enum.entityStatus_abbreviation.${EntityStatus.Inactive}`}
              defaultMessage="I"
            />
          </Radio.Button>
        </Tooltip>
      </Radio.Group>
    </Form.Item>
  );
};

EntityStatusInput.propTypes = {
  parentComponent: string.isRequired,
  field: object,
  formProperty: object,
  validateProjectMilestoneActive: func,
  isNewProjectType: bool,
};

export default EntityStatusInput;
